import { useQuery } from '@tanstack/react-query';
import { Fund } from '../types';

type Props = {
  clientId?: string;
};

export const useFunds = (props?: Props) => {
  const resource = props?.clientId ? `clients/${props.clientId}/funds` : 'funds';

  const { data, isLoading, refetch, error, isError } = useQuery<Fund[]>({
    queryKey: [resource],
  });

  return {
    funds: data ?? [],
    isLoading,
    error,
    isError,
    refetch,
  };
};
